<template>
  <div class="hello flex">
    <info @showdialogVisible="showdialogVisible" ref="child" :data="childInfo"></info>
    <div style="width:1050px!important;text-align: left;">
      <div class="form">
        <el-form :inline="true" :model="data" class="demo-form-inline" label-width="100px" label-position="left">
          <el-form-item label="成绩单命名">
            <el-input v-model="data.title" placeholder="请输入内容" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="考试时间">
            <el-date-picker v-model="data.exam_at" type="date" placeholder="选择日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="data" class="demo-form-inline" label-width="100px" label-position="left">
          <el-form-item label="学校">
            <el-input v-model="data.school" placeholder="请输入内容" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="年级">
            <el-select v-model="data.grade_name" @change="changeGrade($event)" style="width:200px;">
              <el-option v-for="(item,index) in grade_list" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级">
            <el-input v-model="data.class" placeholder="请输入内容" style="width: 200px;"></el-input>
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="data" class="demo-form-inline" label-width="100px" label-position="left">
          <el-form-item label="省市县">
            <el-select v-model="data.province_id" @change="change0($event)" style="width: 200px;">
              <el-option v-for="item in options0" :key="item.value" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="data.city_id" @change="change($event)" style="width: 200px;">
              <el-option v-for="item in options1" :key="item.value" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="data.county_id" @change="change1($event)" style="width: 200px;">
              <el-option v-for="item in options2" :key="item.value" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="kemu">

        <div>
          <span>选择科目</span>
          <el-checkbox-group v-model="checked" @change='changeGroup' text-color='#C10B17' fill='#C10B17'
            style="text-align: left;margin-top: 10px;">
            <el-checkbox v-for="item in kemu" :label="item.value" :key="item.value" text-color='#C10B17' fill='#C10B17'>
              {{item.label}}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="list flex">
          <div class="flex name" v-show="checked.indexOf('语文')>-1">
            <div>
              <span>语文</span>
              <el-input v-model="data.scores[0].score" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
            <div class="manfen">
              <span>语文满分</span>
              <el-input v-model="data.scores[0].max" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
          </div>
          <div class="flex name" v-show="checked.indexOf('数学')>-1">
            <div>
              <span>数学</span>
              <el-input v-model="data.scores[1].score" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
            <div class="manfen">
              <span>数学满分</span>
              <el-input v-model="data.scores[1].max" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
          </div>
          <div class="flex name" v-show="checked.indexOf('英语')>-1">
            <div>
              <span>英语</span>
              <el-input v-model="data.scores[2].score" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
            <div class="manfen">
              <span>英语满分</span>
              <el-input v-model="data.scores[2].max" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
          </div>
          <div class="flex name" v-show="checked.indexOf('物理')>-1">
            <div>
              <span>物理</span>
              <el-input v-model="data.scores[3].score" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
            <div class="manfen">
              <span>物理满分</span>
              <el-input v-model="data.scores[3].max" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
          </div>
          <div class="flex name" v-show="checked.indexOf('化学')>-1">
            <div>
              <span>化学</span>
              <el-input v-model="data.scores[4].score" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
            <div class="manfen">
              <span>化学满分</span>
              <el-input v-model="data.scores[4].max" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
          </div>
          <div class="flex name" v-show="checked.indexOf('生物')>-1">
            <div>
              <span>生物</span>
              <el-input v-model="data.scores[5].score" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
            <div class="manfen">
              <span>生物满分</span>
              <el-input v-model="data.scores[5].max" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
          </div>

          <div class="flex name" v-show="checked.indexOf('历史')>-1">
            <div>
              <span>历史</span>
              <el-input v-model="data.scores[6].score" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
            <div class="manfen">
              <span>历史满分</span>
              <el-input v-model="data.scores[6].max" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
          </div>
          <div class="flex name" v-show="checked.indexOf('政治')>-1">
            <div>
              <span>政治</span>
              <el-input v-model="data.scores[7].score" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
            <div class="manfen">
              <span>政治满分</span>
              <el-input v-model="data.scores[7].max" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
          </div>
          <div class="flex name" v-show="checked.indexOf('地理')>-1">
            <div>
              <span>地理</span>
              <el-input v-model="data.scores[8].score" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
            <div class="manfen">
              <span>地理满分</span>
              <el-input v-model="data.scores[8].max" placeholder="请输入分数" style="width:200px;"></el-input>
            </div>
          </div>
        </div>
        <button class="sure" @click="save">确定</button>
      </div>
    </div>

  </div>
</template>

<script>
  import info from '../../../components/me/growthInfo.vue'
  export default {
    data() {
      return {
        name: '',
        showdialogVisible: false,
        childInfo: [],
        checked: [],
        options2: [],
        options0: [],
        options1: [],
        grade_list: [
          "高中三年级",
          "高中二年级",
          "高中一年级",
          "初中三年级",
          "初中二年级",
          "初中一年级",
          "小学六年级",
          "小学五年级",
          "小学四年级",
          "小学三年级",
          "小学二年级",
          "小学一年级"
        ],
        kemu: [{
            value: '语文',
            label: '语文'
          },
          {
            value: '数学',
            label: '数学'
          },
          {
            value: '英语',
            label: '英语'
          },
          {
            value: '物理',
            label: '物理'
          },
          {
            value: '化学',
            label: '化学'
          },
          {
            value: '生物',
            label: '生物'
          },

          {
            value: '历史',
            label: '历史'
          },
          {
            value: '政治',
            label: '政治'
          },
          {
            value: '地理',
            label: '地理'
          }
        ],
        scores: [],
        data: {
          title: '',
          province_id: '',
          city_id: '',
          county_id: '',
          class: '',
          exam_time: '',
          school: '',
          exam_at: '',
          grade: '',
          grade_name: '',
          scores: [{
            score: '',
            max: '',
            type: 1
          }, {
            score: '',
            max: '',
            type: 2
          }, {
            score: '',
            max: '',
            type: 3
          }, {
            score: '',
            max: '',
            type: 4
          }, {
            score: '',
            max: '',
            type: 5
          }, {
            score: '',
            max: '',
            type: 6
          }, {
            score: '',
            max: '',
            type: 7
          }, {
            score: '',
            max: '',
            type: 8
          }, {
            score: '',
            max: '',
            type: 9
          }]
        },
        userInfo: [],
        user: []
      }
    },
    components: {
      info
    },
    created() {
      this.$http.userExamInfo().then(res => {
        this.childInfo = res.data.info
        this.checked = res.data.last_score.check_list
        console.log(res.data.last_score.check_list)
      })

      this.$http.getareaList().then(res => {
        this.options0 = res.data.list
      })
      this.$http.userExamInfo().then(res => {
        this.$http.getareaList({
          pid: res.data.info.province_id
        }).then(res => {
          this.options1 = res.data.list
        })
        this.$http.getareaList({
          pid: res.data.info.city_id
        }).then(res => {
          this.options2 = res.data.list
        })
        this.data.school = res.data.info.school
        this.data.province_id = res.data.info.province_id
        this.data.city_id = res.data.info.city_id
        this.data.county_id = res.data.info.county_id
        this.data.class = res.data.info.class
        this.data.school = res.data.info.school
        this.data.grade_name = res.data.info.grade_name
        this.data.grade = res.data.info.grade
        if (res.data.last_score.scores != null) {
          let score = res.data.last_score.scores
          console.log(score)
          for (let i = 0; i < score.length; i++) {
            console.log(score[i])
            for (let p = 0; p < this.data.scores.length; p++) {
              console.log(score[i].type, this.data.scores[p].type)
              if (score[i].type == this.data.scores[p].type) {
                this.data.scores[p].max = score[i].max
              }
            }
          }
        }

      })


    },
    mounted() {

    },
    methods: {
      changeGrade(e) {

        if (e == '高中三年级') {
          this.data.grade = 1
        }
        if (e == '高中二年级') {
          this.data.grade = 2
        }
        if (e == '高中一年级') {
          this.data.grade = 3
        }
        if (e == '初中三年级') {
          this.data.grade = 4
        }
        if (e == '初中二年级') {
          this.data.grade = 5
        }
        if (e == '初中一年级') {
          this.data.grade = 6
        }
        if (e == '小学六年级') {
          this.data.grade = 7
        }
        if (e == '小学五年级') {
          this.data.grade = 8
        }
        if (e == '小学四年级') {
          this.data.grade = 9
        }
        if (e == '小学三年级') {
          this.data.grade = 10
        }
        if (e == '小学二年级') {
          this.data.grade = 11
        }
        if (e == '小学一年级') {
          this.data.grade = 12
        }
      },
      save() {
        // this.data.school = this.user.school
        // this.data.province_id = this.user.province_id
        // this.data.city_id = this.user.city_id
        // this.data.county_id = this.user.county_id
        // this.data.class = this.user.class

        this.data.exam_time = this.data.exam_at
        console.log(this.data)
        if (this.checked.length == 0) {
          this.$message.error('请先完善信息')
          return
        }
        if (this.data.exam_at == '') {
          this.$message.error('请选择考试时间')
          return
        }
        if (this.data.title == '') {
          this.$message.error('请填写成绩单名字')
          return
        }
        this.$http.userExamScoreAdd(this.data).then(res => {
          if (res.code == 200) {
            this.$message.success('添加成功')
            setTimeout(() => {
              this.$router.push('/growthRecord')
            }, 1500)

          }
        })
      },
      change0(e) {
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.options1 = res.data.list
        })
      },
      changeYear() {
        this.$http.subjectTypeList({
          province_id: this.userInfo.province,
          year: this.userInfo.year
        }).then(res => {
          this.type = res.data.type
          if (res.data.type == 2) {
            this.options3 = res.data.select[1]
          } else {
            this.options3 = res.data.select
          }

        })
      },
      change(e) {
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.options2 = res.data.list
        })
      },
      change1(e) {
        this.userInfo.county = e
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.options2 = res.data.list
        })
      },
      change2(e) {
        this.userInfo.grade = e
      },
      change3(e) {
        console.log(e)
        this.userInfo.subject_type_1 = e
      }
    }
  }
</script>

<style scoped lang="scss">
  $color:#C10B17;

  .manfen {
    margin-left: 40px;
  }

  .sure {
    width: 58px;
    height: 36px;
    background: #C10B17;
    border-radius: 4px;
    color: #FFFFFF;
    display: block;
    margin: 20px auto;
  }

  .name {
    // width: 50%;
    margin-top: 20px;

    span {
      margin-right: 30px;
    }
  }

  .kemu {
    width: 981px;

    border: 1px solid #EDEDED;
    border-radius: 10px;
    margin: 20px 0;

    &>div {
      margin: 10px;
    }
  }

  .hello {
    justify-content: space-between;
    align-items: flex-start;
  }

  button {
    width: 147px;
    height: 33px;
    border: 1px solid #C10B17;
    border-radius: 6px;
    background-color: #FFFFFF;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #C10B17;
    margin-top: 15px;
  }

  .info {
    width: 205px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;
    border: 1px solid #EDEDED;
    text-align: center;
    padding-bottom: 20px;



    &>p {
      width: 100%;

      margin: 20px 0px 20px 0px;
    }

    .head {
      width: 100%;
      height: 60px;
      background: #C10B17;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }

  .form {
    margin-top: 20px;
  }
</style>
<style>
  .el-radio__input.is-checked+.el-radio__label {
    color: #C10B17 !important;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: #C10B17 !important;
    border-color: #C10B17 !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #C10B17 !important;
    background-color: #C10B17 !important;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #C10B17 !important;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #C10B17 !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/me/growthRecord/addRecord.vue